import { KeyValue } from '@jobcost-monorepo/utils';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { MODULE } from '../../common';

export function enumToKeyValueArray<T extends object>(
  enumType: T,
  enumName: string,
  translationModuleName: MODULE,
): KeyValue[] {
  const { t } = useTranslation(translationModuleName?.toLocaleLowerCase());
  return Object.keys(enumType).map((key) => {
    return {
      id: enumType[key as keyof T] as string,
      name: t(`enum.${enumName}.${key}`),
    };
  });
}
